import React from 'react';
import './exp.scss';

const context = {
    ru: {
        title: 'Опыт работы',
        data: [
            {
                title: 'ГАЛАКТИКА. Фронтенд разработчик.',
                date: 'Февраль 2020 - Настоящее время',
                text: 'Стэк: Angular 8, Devextreme, RxJs, PostgreSQL. Разработка новых интерфейсов. Исправление багов',
            },
            {
                title: 'DW. Фронтенд разработчик.',
                date: 'Август 2019 - Январь 2020',
                text: 'Angular 8, Angular Material UI, RxJs, IndexedDB, NodeJS, ReactJS, NextJS... Разработка новых интерфейсов. Исправление багов',
            },
            {
                title: 'RSSchool. Студент.',
                date: 'Сентябрь 2018 - Март 2019',
                text: 'Разработал несколько учебных проектов (в портфолио). Работа в команде. Использую VSCode, JavaScript, git, Webpack, React... ',
            },
            {
                title: 'Аксиома-Сервис. Инженер.',
                date: 'Июль 2017 - по июль 2019',
                text: 'Обслуживание системы кабельного телевидения. Создал и сопровождал базу данных оборудования и электронный справочник телеканалов в системе. Angular, Firebase, Typescript',
            },
        ],
    },
    en: {
        title: 'Experience',
        data: [
            {
                title: 'GALAKTIKA. Frontend developer.',
                date: 'February 2020 - Present time',
                text: 'Angular 8, Devextreme, RxJs, PostgreSQL. Сreation of new interfaces. Fixing bugs',
            },
            {
                title: 'DW. Frontend developer.',
                date: 'August 2019 - January 2020',
                text: 'Angular 8, Angular Material UI, RxJs, IndexedDB, NodeJS, ReactJS, NextJS... Сreation of new interfaces. Fixing bugs',
            },
            {
                title: 'RSSchool. Student.',
                date: 'September 2018 - March 2019',
                text: 'Developed several training projects (in portfolio). Work in team. Used VSCode, JavaScript, git, Webpack, React, Angular... ',
            },
            {
                title: 'Axioma-Service. Engineer.',
                date: 'July 2017 - July 2019',
                text: 'Cable TV system service. Created and maintained a database of equipment and electronic directory of TV channels in the system. Used Angular, Firebase, Typescript',
            },
        ],
    },
};

const Exp = ({ lang }) => {
    const { title, data } = context[lang];
    return (
        <div className='Edu'>
            <hr />
            <h4>{title}</h4>
            <hr />
            <table>
                <tbody>
                    {data.map((item, index) => {
                        return (
                            <tr key={index}>
                                <td>{item.title}</td>
                                <td>{item.date}</td>
                                <td>{item.text}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default Exp;
